var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"in-report-manage"},[_c(_vm.views,{tag:"component"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }